module.exports = __webpack_public_path__ + "static/media/image.c8c8347c.png";